/**
 * Gössl Store-Modus (r39c) — "Sie stöbern im Gwandhaus X".
 * Entered via the printed QR cards in the Geschäfte
 * (goessl.com/?geschaeft=<page-handle>&gn=<Name>). Remembers the store in
 * localStorage, shows a dismissible pill, and the PDP availability block +
 * Filial-Stück card pin that store first. Cleared via the pill's Beenden.
 */
(function () {
  'use strict';

  var KEY = 'g26_store';

  function read() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || 'null');
      return s && s.page ? s : null;
    } catch (e) { return null; }
  }
  function write(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }
  function clear() {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }

  // Capture ?geschaeft= from the QR entry, then clean the URL.
  (function capture() {
    var params = new URLSearchParams(window.location.search);
    var page = (params.get('geschaeft') || '').toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 60);
    if (!page) return;
    var name = (params.get('gn') || '').slice(0, 48);
    write({ page: page, name: name, ts: Date.now() });
    params.delete('geschaeft'); params.delete('gn');
    var qs = params.toString();
    try { history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '')); } catch (e) {}
  })();

  var store = read();

  // Store coordinates for the plausibility check that runs when the customer
  // OPENS THE CAMERA SCANNER in store mode (from the Geschäfte map, r51) —
  // never automatically on QR entry. Position is evaluated ON DEVICE only — it is never
  // sent anywhere; the only thing that can change is which store the mode
  // pins, which is the same data the QR itself carries. Stores without map
  // coordinates (Baden) simply skip the check.
  var GEO = {
    "goessl-bad-hofgastein": [47.1726, 13.1025, "Bad Hofgastein"],
    "goessl-bad-ischl": [47.711, 13.6223, "Bad Ischl"],
    "goessl-bad-reichenhall": [47.7233, 12.8783, "Bad Reichenhall"],
    "goessl-dornbirn": [47.4138, 9.7426, "Dornbirn"],
    "goessl-fuessen": [47.5684, 10.7, "Füssen"],
    "goessl-graz": [47.0691, 15.4389, "Graz"],
    "goessl-innsbruck": [47.2682, 11.3934, "Innsbruck"],
    "goessl-kitzbuehel": [47.447, 12.39, "Kitzbühel"],
    "goessl-landshut": [48.5332, 12.1499, "Landshut"],
    "goessl-lech": [47.2111, 10.1437, "Lech"],
    "goessl-leibnitz": [46.7813, 15.5386, "Leibnitz"],
    "goessl-linz": [48.3017, 14.2887, "Linz"],
    "goessl-muenchen": [48.14, 11.5774, "München"],
    "goessl-regensburg": [49.019, 12.0985, "Regensburg"],
    "goessl-rottach-egern": [47.6944, 11.7677, "Rottach"],
    "goessl-im-gwandhaus": [47.7793, 13.0581, "Gössl im Gwandhaus"],
    "goessl-st-poelten": [48.2044, 15.6241, "St. Pölten"],
    "goessl-st-veit": [46.7678, 14.3585, "St.Veit"],
    "goessl-steyr": [48.0384, 14.4184, "Steyr"],
    "goessl-tamsweg": [47.1257, 13.8102, "Tamsweg"],
    "goessl-traunstein": [47.8685, 12.6431, "Traunstein"],
    "goessl-wien": [48.2071, 16.3725, "Wien"]
  };

  function distM(lat1, lng1, lat2, lng2) {
    var R = 6371000, r = Math.PI / 180;
    var dLat = (lat2 - lat1) * r, dLng = (lng2 - lng1) * r;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * r) * Math.cos(lat2 * r) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(a));
  }

  // Decide from a device position whether the scanned store is plausible.
  // Intervenes ONLY on a clear mismatch (another Gössl store is right here,
  // the scanned one is far away) — ambiguity always keeps the card's store.
  function geoDecide(lat, lng, accuracy) {
    if (!store || !GEO[store.page]) return null;
    if (accuracy && accuracy > 800) return null; // too fuzzy to judge
    var here = GEO[store.page];
    var scannedDist = distM(lat, lng, here[0], here[1]);
    if (scannedDist <= 450) return { ok: true };
    var bestPage = null, bestDist = Infinity;
    for (var p in GEO) {
      if (p === store.page) continue;
      var d = distM(lat, lng, GEO[p][0], GEO[p][1]);
      if (d < bestDist) { bestDist = d; bestPage = p; }
    }
    if (bestDist <= 450 && scannedDist >= 1500) {
      return { ok: false, page: bestPage, name: GEO[bestPage][2] };
    }
    return null;
  }

  function switchStore(page, name) {
    store = { page: page, name: name, ts: Date.now() };
    write(store);
    var label = document.querySelector('.g26-storemode__label');
    if (label) label.textContent = window.g26tText('stores.store_mode.browsing', 'Sie stöbern im Gwandhaus {{ store }}', { store: prettyName(store) });
  }

  function showGeoBanner(suggestion) {
    if (document.querySelector('.g26-storemode-geo')) return;
    var box = document.createElement('div');
    box.className = 'g26-storemode-geo';
    var txt = document.createElement('p');
    txt.className = 'g26-storemode-geo__text';
    txt.textContent = window.g26tText('stores.store_mode.geo_question', 'Sind Sie im Gwandhaus {{ suggested }}? Der gescannte Code gehört zu {{ scanned }}.', { suggested: suggestion.name, scanned: prettyName(store) });
    var row = document.createElement('div');
    row.className = 'g26-storemode-geo__row';
    var yes = document.createElement('button');
    yes.type = 'button';
    yes.className = 'btn btn--s4';
    yes.textContent = window.g26tText('stores.store_mode.switch_to', 'Zu {{ store }} wechseln', { store: suggestion.name });
    yes.addEventListener('click', function () {
      switchStore(suggestion.page, suggestion.name);
      try { sessionStorage.removeItem(SUGGEST_KEY); } catch (e) {}
      box.remove();
    });
    var no = document.createElement('button');
    no.type = 'button';
    no.className = 'g26-storemode-geo__keep';
    no.textContent = window.g26tText('stores.store_mode.keep', '{{ store }} behalten', { store: prettyName(store) });
    no.addEventListener('click', function () {
      try { sessionStorage.removeItem(SUGGEST_KEY); } catch (e) {}
      box.remove();
    });
    row.appendChild(yes); row.appendChild(no);
    box.appendChild(txt); box.appendChild(row);
    document.body.appendChild(box);
  }

  var SUGGEST_KEY = 'g26_geo_suggest';

  function geoVerifyAt(lat, lng, accuracy) {
    var d = geoDecide(lat, lng, accuracy);
    if (d && d.ok === false) {
      try { sessionStorage.setItem(SUGGEST_KEY, JSON.stringify(d)); } catch (e) {}
      showGeoBanner(d);
    }
    return d;
  }

  // Called by the tag scanner when the customer opens the camera — the one
  // moment they are deliberately "scanning here", so camera and location
  // permission belong to the same gesture. One check per store and session.
  function geoCheck() {
    if (!store || !GEO[store.page]) return;
    if (!('geolocation' in navigator)) return;
    var guard = 'g26_geo_' + store.page;
    try { if (sessionStorage.getItem(guard)) return; sessionStorage.setItem(guard, '1'); } catch (e) {}
    setTimeout(function () {
      navigator.geolocation.getCurrentPosition(function (pos) {
        geoVerifyAt(pos.coords.latitude, pos.coords.longitude, pos.coords.accuracy);
      }, function () { /* denied or unavailable — the card's store stands */ },
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 });
    }, 600);
  }

  function prettyName(s) {
    if (s.name) return s.name;
    return s.page.replace(/^goessl-(am-|im-)?/, '').split('-').map(function (w) {
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  function renderPill() {
    if (!store || document.querySelector('.g26-storemode')) return;
    var pill = document.createElement('div');
    pill.className = 'g26-storemode';
    var label = document.createElement('span');
    label.className = 'g26-storemode__label';
    label.textContent = window.g26tText('stores.store_mode.browsing', 'Sie stöbern im Gwandhaus {{ store }}', { store: prettyName(store) }); // textContent — no markup risk
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'g26-storemode__close';
    btn.setAttribute('aria-label', window.g26tText('stores.store_mode.end', 'Store-Modus beenden'));
    btn.textContent = '×';
    btn.addEventListener('click', function () {
      clear();
      pill.remove();
      store = null;
    });
    pill.appendChild(label);
    pill.appendChild(btn);
    document.body.appendChild(pill);
  }

  function init() {
    renderPill();
    // PDP: open the availability accordion straight away in store mode.
    if (store) {
      var acc = document.querySelector('[data-store-availability]');
      if (acc && !acc.open) acc.open = true;
      try {
        var pending = JSON.parse(sessionStorage.getItem(SUGGEST_KEY) || 'null');
        if (pending && pending.page && GEO[pending.page]) showGeoBanner(pending);
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.GoesslStoreMode = { get: read, clear: clear, geoCheck: geoCheck, _geoVerifyAt: geoVerifyAt };
})();
